 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A1_FRONTCOVERIMAGE from '@/components/01_frontcoverImage'
 import A2_TITLEPAGEIMAGE from '@/components/02_titlepageImage'
 import A2A_TOC from '@/components/02a_toc'
 import A2B_NOTE from '@/components/02b_note'
 import A2B_PREFACE from '@/components/02b_preface'
 import A2BA_INTRODUCTION from '@/components/02ba_Introduction'
 import A4_CH01 from '@/components/04_ch01'
 import A5_CH02 from '@/components/05_ch02'
 import A6_CH03 from '@/components/06_ch03'
 import A7_CH04 from '@/components/07_ch04'
 import A8_CH05 from '@/components/08_ch05'
 import A9_CH06 from '@/components/09_ch06'
 import A0_BIBLIO from '@/components/10_biblio'
 import A1_AUTHOR from '@/components/11_author'
 import A2A_COPYRIGHT from '@/components/02a_copyright'
 import A2_BACKCOVER from '@/components/12_backcover'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/02a_toc",
 			"name" : "02a_toc",
 			"component" : A2A_TOC
 		},
 		{
 			"path" : "/02b_note",
 			"name" : "02b_note",
 			"component" : A2B_NOTE
 		},
 		{
 			"path" : "/02b_preface",
 			"name" : "02b_preface",
 			"component" : A2B_PREFACE
 		},
 		{
 			"path" : "/02ba_Introduction",
 			"name" : "02ba_Introduction",
 			"component" : A2BA_INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js